import React, { useState } from "react";
import { sendPasswordResetEmail } from "firebase/auth";
import { useNavigate } from "react-router-dom";
import { auth } from "../firebase";
import { Button } from "../design/button";
import { Divider } from "../design/divider";
import { FieldGroup, Fieldset, Label } from "../design/fieldset";
import { Heading } from "../design/heading";
import { Input } from "../design/input";
import { Field } from "../design/fieldset";

import { Text } from "../design/text";
import { Link } from "../design/link";
import { useTenant } from "../contexts/TenantContext";
import LogoHorizontal from "../components/LogoHorizontal";

const ForgotPasswordPage: React.FC = () => {
  const { tenant, loading: loadingTenant } = useTenant();
  const [email, setEmail] = useState("");
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [isPasswordReset, setIsPasswordReset] = useState(false);
  const navigate = useNavigate();

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setIsSubmitting(true);
    try {
      await sendPasswordResetEmail(auth, email);
      setIsPasswordReset(true);
    } catch (error) {
      console.error("Authentication error", error);
      alert(error);
    }
    setIsSubmitting(false);
  };

  return (
    <div className="flex items-center justify-center min-h-screen">
      <form
        method="post"
        className="w-full max-w-lg p-6 bg-white rounded-lg shadow-lg dark:bg-gray-800"
        onSubmit={handleSubmit}
      >
        <div className="items-center w-full my-6 text-center">
          {!loadingTenant && (
            <LogoHorizontal
              href="/"
              tenant={tenant}
              className="items-center h-10 mx-auto"
            />
          )}
        </div>
        <Fieldset>
          <Heading className="text-2xl font-semibold text-center">
            Forgot Password
          </Heading>
          <Divider className="my-6" />
          {isPasswordReset && (
            <>
              <Text className="text-center">
                We've sent you an email with instructions on how to reset your
                password.
              </Text>
              <Divider className="my-6" />
              <Button onClick={() => navigate("/login")} className="w-full">
                Back to Login
              </Button>
            </>
          )}
          {!isPasswordReset && (
            <>
              <FieldGroup>
                <Field>
                  <Label htmlFor="email">Email</Label>
                  <Input
                    id="email"
                    aria-label="Email"
                    type="email"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    placeholder="Enter your email"
                  />
                </Field>
              </FieldGroup>
              <Divider className="my-6" />
              <Button type="submit" className="w-full" disabled={isSubmitting}>
                {isSubmitting
                  ? "Sending email..."
                  : "Send Password Reset Email"}
              </Button>
              <div className="my-6 text-center">
                <Text>
                  <Link href="/login" className="text-blue-600 hover:underline">
                    Wait I remember my password
                  </Link>
                </Text>
              </div>
            </>
          )}
        </Fieldset>
      </form>
    </div>
  );
};

export default ForgotPasswordPage;
